<template>
  <div v-if="eventModifier.length === 0" :style="styles.container" @click="(e) => $emit('click', e)">
    <slot />
  </div>
  <div v-else-if="eventModifier === 'stop'" :style="styles.container" @click.stop="(e) => $emit('click', e)">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

type AlignItems = 'center' | 'end' | 'flex-end' | 'flex-start' | 'start' | 'stretch' | 'baseline';
type JustifyContent = AlignItems | 'space-around' | 'space-between' | 'space-evenly';
export type FlexDirection = 'column' | 'column-reverse' | 'row' | 'row-reverse';
type FlexWrap = 'wrap' | 'nowrap' | 'wrap-reverse';

export default defineComponent({
  name: 'Flex',
  props: {
    justifyContent: {
      type: String as PropType<JustifyContent>,
      default: 'start',
    },
    alignItems: {
      type: String as PropType<AlignItems>,
      default: 'start',
    },
    flexDirection: {
      type: String as PropType<FlexDirection>,
      default: 'row',
    },
    flexWrap: {
      type: String as PropType<FlexWrap>,
      default: 'nowrap',
    },
    containerWidth: {
      type: String,
    },
    containerMinWidth: {
      type: String,
    },
    eventModifier: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const styles = {
      container: {
        display: 'flex',
        justifyContent: props.justifyContent,
        alignItems: props.alignItems,
        flexDirection: props.flexDirection,
        flexWrap: props.flexWrap,
        width: props.containerWidth,
        minWidth: props.containerMinWidth,
      },
    };

    return {
      styles,
    };
  },
});
</script>
